import { render, staticRenderFns } from "./File-Extension.vue?vue&type=template&id=32296a79&scoped=true&"
import script from "./File-Extension.vue?vue&type=script&lang=js&"
export * from "./File-Extension.vue?vue&type=script&lang=js&"
import style0 from "./File-Extension.vue?vue&type=style&index=0&id=32296a79&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32296a79",
  null
  
)

export default component.exports